var SearchBarV2Module_1;
import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonV2Module } from '../button-v2';
import { FieldErrorModule } from '../field-error';
import { IconModule } from '../icon-v2';
import { SearchBarV2Component } from './search-bar-v2.component';
import { ConstructorName, SharedModule } from '../../shared';
import * as i0 from "@angular/core";
import * as i1 from "../../shared";
let SearchBarV2Module = class SearchBarV2Module {
  static {
    SearchBarV2Module_1 = this;
  }
  monitoringService;
  constructor(monitoringService) {
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', SearchBarV2Module_1), 'constructor');
  }
  static ɵfac = function SearchBarV2Module_Factory(t) {
    return new (t || SearchBarV2Module)(i0.ɵɵinject(i1.MonitoringService));
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SearchBarV2Module
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FieldErrorModule, TranslateModule, SharedModule, NgxSkeletonLoaderModule, InputTextModule, AutoCompleteModule, ButtonV2Module, IconModule]
  });
};
SearchBarV2Module = SearchBarV2Module_1 = __decorate([ConstructorName('SearchBarV2Module')], SearchBarV2Module);
export { SearchBarV2Module };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchBarV2Module, [{
    type: NgModule,
    args: [{
      declarations: [SearchBarV2Component],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FieldErrorModule, TranslateModule, SharedModule, NgxSkeletonLoaderModule, InputTextModule, AutoCompleteModule, ButtonV2Module, IconModule],
      exports: [SearchBarV2Component]
    }]
  }], () => [{
    type: i1.MonitoringService
  }], null);
})();
